import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { Link } from "@opensea/next-ui-kit";
import { Chip, classNames, formatAddress, TextOverflowTooltip } from "@opensea/ui-kit";
import { Verified } from "@opensea/ui-kit/icons";
import { useTranslations } from "next-intl";
import { getProfileUrlWithView } from "@/components/account/utils";
import { ProfilePreviewTooltip } from "@/components/profile/ProfilePreviewTooltip/ProfilePreviewTooltip";
import { CollectionOwnerFragment } from "./CollectionOwner.fragment";
export function CollectionOwner(t0) {
  const $ = _c(19);
  const {
    collection: collectionKey,
    variant: t1,
    chipVariant,
    renderAsChip: t2,
    overrides,
    prefix
  } = t0;
  const variant = t1 === undefined ? "full" : t1;
  const renderAsChip = t2 === undefined ? true : t2;
  const collection = readFragment(CollectionOwnerFragment, collectionKey);
  const t = useTranslations("CollectionOwner");
  if (!collection.owner) {
    return null;
  }
  const ownerName = collection.owner.displayName || formatAddress(collection.owner.address, {
    display: "compact"
  });
  let t3;
  if ($[0] !== ownerName || $[1] !== prefix || $[2] !== t) {
    t3 = prefix ? <>{prefix} {ownerName}</> : t.rich("by", {
      owner: () => <>{ownerName}</>
    });
    $[0] = ownerName;
    $[1] = prefix;
    $[2] = t;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const innerContent = t3;
  const t4 = renderAsChip ? <TextOverflowTooltip className={classNames("max-w-[150px]", {
    "3xl:max-w-[150px] md:max-w-[120px]": variant === "compact" && collection.standard === "ERC721",
    "md:max-w-[100px]": variant === "compact" && collection.standard === "ERC1155",
    "md:max-w-[150px]": variant === "full"
  })} disabled={true}>{innerContent}</TextOverflowTooltip> : <span>{innerContent}</span>;
  const t5 = collection.owner.isVerified ? <Verified size={overrides?.VerifiedIcon?.size ?? 12} {...renderAsChip ? {
    fill: "text-primary",
    innerFill: "transparent"
  } : {}} {...overrides?.VerifiedIcon} className={classNames("ml-1", overrides?.VerifiedIcon?.className)} /> : null;
  let t6;
  if ($[4] !== t4 || $[5] !== t5) {
    t6 = <>{t4}{t5}</>;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const content = t6;
  let t7;
  if ($[7] !== chipVariant || $[8] !== content || $[9] !== renderAsChip) {
    t7 = renderAsChip ? <Chip variant={chipVariant}>{content}</Chip> : content;
    $[7] = chipVariant;
    $[8] = content;
    $[9] = renderAsChip;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const wrappedContent = t7;
  const T0 = ProfilePreviewTooltip;
  const t8 = collection.owner;
  const T1 = Link;
  const t9 = "flex items-center";
  const t10 = getProfileUrlWithView(collection.owner, "created");
  let t11;
  if ($[11] !== T1 || $[12] !== t10 || $[13] !== wrappedContent) {
    t11 = <T1 className={t9} href={t10} variant="unstyled">{wrappedContent}</T1>;
    $[11] = T1;
    $[12] = t10;
    $[13] = wrappedContent;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== T0 || $[16] !== collection || $[17] !== t11) {
    t12 = <T0 profile={t8}>{t11}</T0>;
    $[15] = T0;
    $[16] = collection;
    $[17] = t11;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  return t12;
}